import { GameState, GameStateType, gameStates } from './state-types';
import { gameState } from '@src/store';

class GameStateMachine {
    states: GameState[] = [];
    currentState: GameState | null = null;

    addState(state: GameState) {
        this.states.push(state);
    }

    setState(stateName: GameStateType) {
        const state = this.states.find(state => state.name === stateName);
        if (!state) {
            throw new Error(`State ${stateName} not found`);
        }

        if (this.currentState) {
            this.currentState.onExit?.();
        }

        this.currentState = state;
        gameState.set(stateName);
        this.currentState.onEnter(this.setState.bind(this));
    }

    getState() {
        return this.currentState;
    }

    start() {
        this.setState(gameStates.init);
    }
}

export const stateMachine = new GameStateMachine();
